"use client";
import { getRealmStorage, resetState } from "../actions";
import { getCodeStateQueryParams } from "./utils";
export const resolveRealm = ({ openidRealmConfig, defaultRealm }) => {
    const { realmParam } = getCodeStateQueryParams();
    const realmStorage = getRealmStorage();
    const hasRealmInQueryParams = realmParam && realmParam !== realmStorage && realmParam in openidRealmConfig;
    if (hasRealmInQueryParams) {
        resetState();
        return realmParam;
    }
    else if (realmStorage in openidRealmConfig && realmStorage) {
        return realmStorage;
    }
    else {
        return defaultRealm;
    }
};
//# sourceMappingURL=resolveRealm.js.map